import { useCallback } from 'react';
import { stopPropagation } from '../events';

export function useEventCallbackWithoutPropagation(callback, deps) {
  return useCallback((event) => {
    stopPropagation(event);
    callback(event);
  }, deps);
}
